<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-card elevation="12" max-width="350">
        <v-card-title class="px-0 pt-0">
          <v-card flat tile color="primary" class="py-2">
            <v-container class="pa-0">
              <v-row align="center">
                <v-col class="pa-0" align="center">
                  <v-img
                    src="../assets/img/geoclock_logo.png"
                    class="login-logo"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-card-title>
        <v-card-text v-if="samlLogoutPage">
          <h2 style="text-align: center">
            {{ $t('login.ssoLoggedOut') }}
          </h2>
        </v-card-text>
        <v-card-text v-else>
          <v-form
            v-model="valid"
            ref="form"
            lazy-validation
          >
            <v-text-field
              v-model="username"
              autofocus
              outlined
              :rules="rules"
              :disabled="loginSubmitted"
              :placeholder="`${$t('login.username')}`"
              @keyup.enter="login"
            />
            <v-text-field
              class="mt-2"
              v-model="password"
              type="password"
              :rules="rules"
              outlined
              :disabled="loginSubmitted"
              :placeholder="`${$t('login.password')}`"
              @keyup.enter="login"
              required
            />
            <v-alert
              v-model="loginError"
              outlined
              type="error"
              class="mt-1 mb-0"
            >
              {{
                loginErrorMessage === ''
                  ? $t('dialogs.error.usernameDoesNotExist.message')
                  : loginErrorMessage
              }}
            </v-alert>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn
            depressed
            block
            :loading="loginSubmitted"
            color="secondary lighten-2"
            type="submit"
            @click="handleAction"
          >
            {{
              samlLogoutPage ? $t('login.loginSSOButton')
                : $t('login.loginButton')
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

import AuthorisationUtil from '@/util/authorisation-util';
import hasSamlFeature from '@/mixins/hasSamlFeature';

export default {
  name: 'Login',
  components: {},

  mixins: [
    hasSamlFeature,
  ],

  props: {
    logout: Boolean,
  },

  data() {
    return {
      username: '',
      password: '',
      loginError: false,
      loginErrorMessage: '',
      loginSubmitted: false,
      valid: true,
      rules: [
        (value) => !!value || 'Field is required.',
      ],
      samlLogoutPage: false,
    };
  },

  async created() {
    await this.fetchFeatureSwitches().then(() => {
      this.samlLogoutPage = this.logout && this.isSamlEnabled;

      if (this.isSamlEnabled && !this.logout) {
        window.location.href = '/unauthorized.html';
      }
    });
  },

  methods: {
    ...mapActions(['loginUser', 'fetchFeatureSwitches']),

    handleAction() {
      if (this.samlLogoutPage) {
        this.toSSOLogin();
      } else {
        this.login();
      }
    },

    login() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loginSubmitted = true;
        const credentials = { username: this.username, password: this.password };
        this.loginUser(credentials)
        .then(() => {
          this.navToLandingPage();
        })
        .catch((error) => {
          this.loginError = true;
          this.loginErrorMessage = error.response.data;
          this.username = '';
          this.password = '';
        })
        .finally(() => {
          this.loginSubmitted = false;
        });
      }
    },

    navToLandingPage() {
      if (AuthorisationUtil.isManager()) {
        this.$router.push({ name: 'Approvals' });
      } else {
        this.$router.push({ name: 'Clock' });
      }
    },

    toSSOLogin() {
      window.location.href = '/saml/login';
    },
  },
};
</script>

<style scoped lang="scss">
.login-logo {
  margin: 10px;
  width: 60%;
  height: 30%;
}
</style>
